import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  deleteSearchParams,
  updateSearchParams
} from 'services/navigation/paths';

type Props = {
  searchText: string;
  searchKey: string;
};

export const useSearchWithSearchParamEffect = ({
  searchText,
  searchKey
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchText) {
      updateSearchParams({
        searchParams: searchParams,
        newParam: {
          key: searchKey,
          value: searchText
        },
        setSearchParams
      });
    } else {
      deleteSearchParams({
        searchParams: searchParams,
        key: searchKey,
        setSearchParams
      });
    }
  }, [searchText, searchParams, searchKey]);
};
